import { random, times, shuffle } from "lodash";
import toWav from "audiobuffer-to-wav";
import { Sound } from "./core";
import {
  REQUEST_UPLOAD_URL,
  SOUND_REVERSAL_PROBABILITY,
  SOUND_FREEZE_PROBABILITY,
  SOUND_EVENT_NAME
} from "./constants";
import {
  playChoirResponse,
  ChoirResponsePlayStatus
} from "./choirResponsePlayer";
import { reverseSound, freezeSound } from "./audio";

const RESPONSE_CHORD_SIZE = [5, 7];

export async function fetchRandomSounds(base: Sound, n = 3): Promise<Sound[]> {
  let reversed = reverseSound(base);
  let frozen: Sound;
  try {
    frozen = await freeze(base);
  } catch (e) {
    console.error("could not freeze", e);
    frozen = base;
  }
  let result = times(10, () => base);
  result = result.concat(
    times(10 * SOUND_REVERSAL_PROBABILITY, () => reversed)
  );
  result = result.concat(times(10 * SOUND_FREEZE_PROBABILITY, () => frozen));
  return shuffle(result);
  //   let index = (await fetch(`${FINAL_SOUNDS_BUCKET}/index.json`).then(r =>
  //     r.json()
  //   )) as SoundIndex;
  //   let randomPicks = sampleSize(index, n);
  //   let result: Sound[] = [];
  //   for (let { name, metadata } of randomPicks) {
  //     let data = await fetch(`${FINAL_SOUNDS_BUCKET}/${name}`)
  //       .then(r => r.arrayBuffer())
  //       .then(arr => audioCtx.decodeAudioData(arr));
  //     result.push({ data, metadata });
  //   }
  //   return result;
}

async function freeze(sound: Sound) {
  let minStartPoint = sound.data.duration * 0.1;
  let maxStartPoint = sound.data.duration * 0.66;
  let minDur = 0.01;
  let maxDur = 0.03;
  let minTotalDur = 3;
  let maxTotalDur = 5;
  let freezePoint =
    minStartPoint + Math.random() * (maxStartPoint - minStartPoint);
  let freezeDur = minDur + Math.random() * (maxDur - minDur);
  let totalDur = minTotalDur + Math.random() * (maxTotalDur - minTotalDur);
  return await freezeSound(sound, freezePoint, freezeDur, totalDur);
}

export async function sendSound(
  sound: Sound,
  minDelay: number,
  responsePlayCallback: () => void
): Promise<ChoirResponsePlayStatus> {
  let wav = toWav(sound.data);
  let delayPromise = delay(minDelay);
  let { uploadUrl, count } = await fetch(REQUEST_UPLOAD_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      metadata: sound.metadata,
      eventName: SOUND_EVENT_NAME
    })
  }).then(res => res.json());
  await fetch(uploadUrl, {
    method: "PUT",
    body: wav
  });
  return Promise.all([
    fetchRandomSounds(
      sound,
      random(RESPONSE_CHORD_SIZE[0], RESPONSE_CHORD_SIZE[1])
    ),
    delayPromise
  ]).then(([resSounds]) =>
    playChoirResponse(sound, resSounds, count, responsePlayCallback)
  );
}

function delay(ms: number) {
  return new Promise(res => setTimeout(res, ms));
}
